import React from "react";
import {MentorshipHero, MentorshipSection } from "../../components/sections/mentorship";

export default function Mentorship(props) {
	return (
		<>
			<MentorshipHero />

			<MentorshipSection/>
		</>
	);
}
